import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import {
    NotifyContainer,
} from './styles'
import NotificationService from 'services/Notification'
import { ICreateNewNotificationResponse, ICreateNotification } from 'types/notification'
import NotifyEventForm from './components/form/NotifyEventForm'
import { notifyEventPatientSchema, NotifyEventPatientType } from 'validator/notify_event_patient_validator'
import { yupResolver } from '@hookform/resolvers/yup';
import NotificationSentSuccess from './components/notification_sent/NotificationSentSuccess'
import { useNavigate } from 'react-router-dom'
import { ROUTES_NAMES } from 'constants/name.routes'
import ComponentLoader from 'components/ComponentLoader'
import { HeaderPatient } from './components/HeaderPatient'

const NotifyEventPatient = () => {
    const navigate = useNavigate()
    const [responseData, setResponseData] = useState<ICreateNewNotificationResponse|null>()

    const {
        register,
        handleSubmit,
        trigger,
        formState: { errors, isDirty },
        control,
        setValue,
        watch,
        getValues,
        reset
    } = useForm<NotifyEventPatientType>({
        resolver: yupResolver(notifyEventPatientSchema)
    })
    const makeNewNotificationFromZero = () => {
        setResponseData(null)
        reset()
        navigate(ROUTES_NAMES.notifyEventPatient, { replace: true })
    }

    if (responseData) {
        
        return (
        <>
            <HeaderPatient />
            <NotifyContainer>
                <NotificationSentSuccess
                    reset={reset}
                    responseData={responseData}
                    setResponseData={setResponseData}
                    makeNewNotificationFromZero={makeNewNotificationFromZero}
                />
            </NotifyContainer>
        </>)
    }
    return (
        <>
            <HeaderPatient />
            <NotifyContainer>
                <NotifyEventForm
                    setResponseData={setResponseData}
                    trigger={trigger}
                    watch={watch}
                    isDirty={isDirty}
                    getValues={getValues}
                    handleSubmit={handleSubmit}
                    register={register}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    reset={reset}
                />
            </NotifyContainer>
        </>
    )
}


export { NotifyEventPatient }

